import { useEffect, useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import i18nStore from "../../../../i18n/store";
import filterStore from "../filters/filtersStore";
import { VectorTypeEnum } from "../../enums";


export const useMuiCalculationsNodesColDefs = (): GridColDef[] => {
    const translations = i18nStore.getTranslations;
    const [colDefs, setColDefs] = useState<GridColDef[]>([]);

    useEffect(() => {
        let newColDefs: GridColDef[] = [
            {
                field: "name",
                headerName: translations.name,
                flex: 1,
                headerAlign: 'center',
            },
        ];

        if (filterStore.getNodeValueTypes.find(vt => vt === VectorTypeEnum.Phase.name)) {
            newColDefs.push(
                {
                    field: "Va",
                    type: 'number',
                    renderHeader: () => (<span>V<sub>a</sub>, {translations._measUnit.kV}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Vb",
                    type: 'number',
                    renderHeader: () => (<span>V<sub>b</sub>, {translations._measUnit.kV}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Vc",
                    type: 'number',
                    renderHeader: () => (<span>V<sub>c</sub>, {translations._measUnit.kV}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_a",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>a</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_b",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>b</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_c",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>c</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
            );
        }
        if (filterStore.getNodeValueTypes.find(vt => vt === VectorTypeEnum.Linear.name)) {
            newColDefs.push(
                {
                    field: "Vab",
                    type: 'number',
                    renderHeader: () => (<span>V<sub>ab</sub>, {translations._measUnit.kV}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Vbc",
                    type: 'number',
                    renderHeader: () => (<span>V<sub>bc</sub>, {translations._measUnit.kV}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "Vca",
                    type: 'number',
                    renderHeader: () => (<span>V<sub>ca</sub>, {translations._measUnit.kV}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_ab",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>ab</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_bc",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>bc</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_ca",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>ca</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
            );
        }
        if (filterStore.getNodeValueTypes.find(vt => vt === VectorTypeEnum.Sequence.name)) {
            newColDefs.push(
                {
                    field: "V1",
                    type: 'number',
                    renderHeader: () => (<span>V<sub>1</sub>, {translations._measUnit.kV}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "V2",
                    type: 'number',
                    renderHeader: () => (<span>V<sub>2</sub>, {translations._measUnit.kV}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "V0",
                    type: 'number',
                    renderHeader: () => (<span>V<sub>0</sub>, {translations._measUnit.kV}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_1",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>1</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_2",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>2</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
                {
                    field: "phi_0",
                    type: 'number',
                    renderHeader: () => (<span>&phi;<sub>0</sub>, {translations._measUnit.grad}</span>),
                    headerAlign: 'center',
                },
            );
        }

        setColDefs(newColDefs);
    }, [i18nStore.getCurrentLanguageCode, filterStore.getNodeValueTypes]);

    return colDefs;
}
